<template>
  <div>
    <v-dialog v-model="mostrar_resultados" persistent>
      <v-card>
        <v-card-title class="headline text-uppercase">FORMULARIO DILIGENCIADO POR {{usuario.name}} {{parametros.bloque === undefined ? '' : `- ${parametros.bloque.nombre}` }}</v-card-title>
        <v-card-text>
          <Respuestas></Respuestas>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" text @click="descargarPdf()">Descargar PDF</v-btn>
          <v-btn color="red darken-1" text @click="mostrar_resultados = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card color="#385F73" dark class="text-justify" style="padding:20px">
      <v-card-title class="headline">Hola {{usuario.name}} !!!</v-card-title>
      <v-divider class="my-3"></v-divider>
      <v-card-text class="font-weight-light">
        Bienvenido al mecanismo de traslado de Versiones Voluntarias y al Formulario en línea de presentación de observaciones sobre las versiones voluntarias practicadas en el marco del Caso No. 01. Hemos diseñado esta herramienta para facilitar que usted presente sus opiniones sobre la información que los comparecientes, es decir, los presuntos responsables de los hechos que causaron la victimización por secuestro, han presentado en esta primera etapa del proceso, en la que se recaudan datos y se contrastan para determinar la verdad de lo sucedido y la responsabilidad de los ex combatientes de las FARC-Ep.
        <br />
        <br />Mediante la presentación de observaciones, usted podrá opinar sobre lo que cree que ha sido la contribución a la verdad de las FARC. Podrá ver y reaccionar a lo que ellos han dicho sobre las retenciones ilegales en las diferentes Versiones Voluntarias que se adelantaron.
        <br />
        <br />Las versiones voluntarias se desarrollaron en tres fases – versiones individuales, versión voluntaria colectiva escrita y ampliación de la versión colectiva oral-, por lo que el traslado al que usted va a acceder a continuación se va a adelantar en tres partes siguiendo el mismo orden. Aquí usted podrá acceder al paquete documental de traslado, de manera progresiva por módulos. Al inicio de cada módulo, usted deberá descargar el documento correspondiente y leerlo detenidamente. Seguidamente, podrá acceder al siguiente módulo, hasta llegar en un último momento al Formulario de presentación de observaciones, en donde deberá dejar sus opiniones de acuerdo con las instrucciones que se le indican.
        <br />
        <br />Para la JEP es fundamental contar con las observaciones desde la voz de las víctimas.
      </v-card-text>
      <v-divider class="my-3"></v-divider>
      <v-card-actions>
        <v-btn
          v-if="!tieneRespuestaTraslado"
          @click="formularioTraslado"
          class="mx-0"
          color="primary"
          large
        >Iniciar</v-btn>
        <v-alert v-if="tieneRespuestaTraslado" color="lime darken-3" style="display:block">
          <label>
            Ud ya ha registrado información en el formulario de traslado de Versiones Voluntarias y al Formulario en línea de presentación de observaciones sobre las versiones voluntarias practicadas en el marco del Caso No. 01.
            <br />
            <br />Para ver el formulario diligenciado por cada uno de los bloques, por favor seleccione el bloque a consultar:
            <br />
            <br />
          </label>
          <div style="display: flex; justify-content: space-between;">
            <v-btn
              class="mx-0"
              color="primary"
              large
              v-for="(traslado, index) in traslados"
              :key="index"
              @click="obtenerResultadoTraslado(traslado.bloque)"
            >{{traslado.bloque.nombre}}</v-btn>
          </div>
        </v-alert>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import Traslado from "../../../services/Traslado";
import router from "../../../router/index.js";
import { EventBus } from "../../../EventBus";
import Auth from "../../../Auth";

export default {
  props: ["tipo", "persona_id"],
  data: () => ({
    usuario: {},
    tieneRespuestaTraslado: true,
    mostrar_resultados: false,
    traslados: [],
    bloque_id: 0,
    parametros: {}
  }),
  created() {
    this.initialize();
  },
  mounted() {},
  components: {},
  computed: {},
  watch: {},
  methods: {
    initialize() {
      this.usuario = { ...user.persona };
      Traslado.getComprobarEstadoTraslado(this.usuario.id).then(response => {
        this.tieneRespuestaTraslado = response.data.tieneRespuestaTraslado;
        this.traslados = response.data.traslados;
      });
    },
    formularioTraslado() {
      router.push({
        name: "traslado-personas-formulario",
        params: { tipo: "personas", persona_id: this.usuario.id }
      });
    },
    obtenerResultadoTraslado(bloque) {
      this.mostrar_resultados = true;
      this.bloque_id = bloque.id;
      this.parametros = {
        bloque: bloque,
        bloque_id: this.bloque_id,
        persona_id: this.usuario.id,
        tipo_usuario: 'persona',
        usuario_id: this.usuario.id
      };
      EventBus.$emit("parametros", this.parametros);
    },
    descargarPdf() {
      let persona_id = this.usuario.id;
      let bloque_id = this.bloque_id;

      // this.show_export_spinner = true;

      let ruta = `/api/traslados/personas/${persona_id}/bloque/${bloque_id}/respuestas/pdf`;
      Traslado.getObtenerPDFResultadoTrasladoXBloque(persona_id, bloque_id)
        .then(response => {
          // this.show_export_spinner = false;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "formulario_traslado.pdf"); //or any other extension

          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          console.log("Ha ocurrido un error en la exportación a PDF");
          this.show_export_spinner = false;
        });
    }
  }
};
</script>
<style lang="css" scoped>
.estilo_dos_columnas {
  width: 50%;
  margin-left: 5px;
  margin-top: 5px;
}
.estilo_tres_columnas {
  width: 33%;
  padding-right: 10px;
  padding-top: 15px;
}
</style>
